import React from 'react'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'

import styles from './Chooseservice.module.scss'
import { H1, H4 } from '../../../../components/UI/index'
import ServiceCard from './components/ServiceCard/ServiceCard'
import { useDispatch, useSelector } from 'react-redux'
import * as FormAction from '../../FormAction'
import I18n from 'i18n-js'

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '60%'
		}
	},
	header: {
		[theme.breakpoints.up('md')]: {
			textAlign: 'center'
		}

	},
	row: {
		[theme.breakpoints.up('md')]: {
			borderBottom: '1px solid #E6E8F2',
			'&:last-child': {
				borderBottom: 0
			}
		}

	},
	card: {
		[theme.breakpoints.down('xs')]: {}
	}
}))

const ChooseService = (props) => {

	const classes = useStyles()

	const {
		services
	} = useSelector(state => state.ConsultantReducer)

	const filteredServices = services.filter(service => service.price !== null)
	const dispatch = useDispatch()

	let main = (

		<Container className={styles.ChooseService} maxWidth="md">
			<div className={classes.header}>
				<H1>{I18n.t('consultant.serviceTitle')}</H1>
				<H4>{I18n.t('consultant.serviceDescription')}</H4>
			</div>
			<div>
				<Grid container justify="center">
					<Grid spacing={3} container>
						{filteredServices.map((filteredService, i) => (
								<Grid xs={12} md={6} item key={filteredService.id}>
									<ServiceCard
										index={i}
										service={filteredService}
										clicked={() => {
											dispatch(FormAction.chooseService(filteredService.id, filteredService.price))
										}}/>
								</Grid>

							)
						)}
					</Grid>
				</Grid>
			</div>
		</Container>

	)

	return (
		<div>
			{main}
		</div>

	)
}

export default ChooseService
